import type { FC, ReactNode } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Card, CardContent } from '@packages/shared/src/ui/Card/Card';
import { Divider } from '@packages/shared/src/ui/Divider/Divider';
import { DynamicSearchField } from '@packages/modules/src/Header/Toolbar/SearchField/SearchField.dynamic';

const allMessages = defineMessages({
  headline: {
    id: 'searchTips.headline',
    defaultMessage: 'Tipps zur weiteren Suche',
  },
  searchTips: {
    id: 'searchTips.bulletPoints',
    defaultMessage:
      '<bullet>Überprüfe deinen Suchbegriff auf Tippfehler.</bullet><bullet>Verwende einen allgemeineren Suchbegriff.</bullet><bullet>Versuche eine Suche mit weniger Wörtern.</bullet><bullet>Umschreibe deinen gesuchten Artikel mit einem anderen Begriff (Synonym)</bullet>',
  },
});

/**
 * Provides a search with tips section for the search result page if no results are available
 * */
export const SearchTipsSection: FC = () => (
  <Card data-testid="search-tips-section">
    <CardContent className="pb-4">
      <h5 className="mb-1">
        <FormattedMessage key="searchTips.headline" {...allMessages.headline} />
      </h5>
      <Divider className="-mx-2" />
      <div className="mt-3 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-12">
        <div className="col-span-1 lg:col-span-4">
          <DynamicSearchField isolated />
        </div>
        <div className="col-span-1 lg:col-span-8">
          <ul className="mt-0 min-h-24">
            <FormattedMessage
              key="searchTips.bulletPoints"
              {...allMessages.searchTips}
              values={{
                bullet: (chunks: ReactNode) => (
                  <li className="text-size-body-sm ml-2 list-disc leading-3">{chunks}</li>
                ),
              }}
            />
          </ul>
        </div>
      </div>
    </CardContent>
  </Card>
);
